import React from 'react'
import { cn } from '../../lib/utils'
import type { BaseComponentProps } from '../../types'
import logoImage from '../../assets/logo.png'

export interface LogoProps extends BaseComponentProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'light' | 'dark' | 'color'
  showText?: boolean
  text?: string
}

const sizeClasses = {
  sm: 'h-8 w-auto',
  md: 'h-12 w-auto',
  lg: 'h-16 w-auto',
  xl: 'h-24 w-auto',
}

export const Logo: React.FC<LogoProps> = ({
  size = 'md',
  variant = 'color',
  showText = true,
  text = 'Präsentationen',
  className,
  ...props
}) => {
  const textColorClass =
    variant === 'light' ? 'text-white' :
    variant === 'dark' ? 'text-foreground' :
    'text-gradient-primary'

  return (
    <div
      className={cn('flex items-center gap-3', className)}
      {...props}
    >
      {/* Logo Image */}
      <img
        src={logoImage}
        alt="Logo"
        className={cn(
          'object-contain',
          sizeClasses[size]
        )}
      />

      {/* Logo Text */}
      {showText && (
        <span
          className={cn(
            'font-bold tracking-tight',
            textColorClass,
            size === 'sm' && 'text-lg',
            size === 'md' && 'text-xl',
            size === 'lg' && 'text-2xl',
            size === 'xl' && 'text-3xl'
          )}
        >
          {text}
        </span>
      )}
    </div>
  )
}
